import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp, CnpjCpfService } from '../../../../../../core';
import { Lead } from '../../../lead';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class LeadIntegracaoEmpresasImportHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp,
                private cnpjCpfService: CnpjCpfService) {
        this.pathApi = `${configServerService.getPathApiIntegrationEmpresas()}/lead`;
    }

    /** Realiza a consulta dos dados de uma empresa através de seu CNPJ e transforma seus dados para um lead */
    consultaCNPJ(cnpj: string): Observable<Lead> {
        cnpj = this.cnpjCpfService.deformatar(cnpj);
        return this.customHttp.get<Lead>(`${this.pathApi}/${cnpj}`)
                    .pipe(
                        map(lead => {
                            // Classificações
                            lead?.classificacoes?.forEach(classificacao => {
                                // Setando que pode editar a classificação
                                classificacao.canEdit = true;
                            })

                            return lead;
                        })
                    );
    }
}
